var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{class:_vm.$style['btn-question'],on:{"click":function($event){return _vm.$refs.rule.show()}}}),_c('popup-frame',{ref:"rule",attrs:{"size":"lg"}},[_c('div',{class:_vm.$style['rules-content'],domProps:{"innerHTML":_vm._s(_vm.teamRule)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }